/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { RegistrationPageProps } from "./interfaces";
import { responsiveStyles } from "../../commons/styles";
import { registrationPageStyle } from "./styles";
import { Card } from "@curefit/pandora";
import backIcon from "../../assets/back-arrow.svg";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import { StatusBar } from "../../atoms/StatusBar";
import { useSTR } from "react-str";
import { URL } from "../../API/urlEndpoints";
import { getData } from "../../utils/fetchers";
import * as _ from "lodash";

import {
  routeURL,
  PropValuesEnum,
  loadingScreenValues,
  getStepStringArrayFromAPI,
  getRequestedPageNumber,
  saveText,
  saveandexit,
} from "../../constants/commons";
import { LanguageProficiency } from "../LanguageProficiency";
import { BasicInformationPage } from "../BasicInformationPage";
import { WorkPlaceDetails } from "../WorkPlaceDetails";
import { useHistory } from "react-router-dom";
import { ProfessionalDetailsPage } from "../ProfessionalDetailsPage";
import { LinkButton } from "../../atoms/LinkButton";
import { PreliminaryQuizPage } from "../PreliminaryQuizPage";
import { SelfieVideoPage } from "../SelfieVideoPage";
import { toast } from "../../utils/toast";
import { LeadState, StepType } from "../../commons/interfaces";
import { ShowMessage } from "../../components/ShowMessage";
import { KYCDetailsPage } from "../KYCDetails";
import { BankAccountDetails } from "../BankAccountDetails";
import { BasicProfileDetailsPage } from "../BasicProfileDetailsPage";
import { useUserContext } from "../../hooks/cookieHooks";
import {
  allowScreenNavigationFromStatusComponent,
  getCurrentPageForStatusComponent,
  getRequestedScreenIndex,
  getStatusComponentDisplayNames,
} from "../../utils/helpers";
import { useMiscellaneousHook } from "../../hooks/useMiscellaneousHook";
import {
  CustomButtonColor,
  CustomButtonTypes,
} from "../../atoms/CustomButton/interface";
import { ErrorComponent } from "../../molecules/ErrorComponent";
import { DigitalCoursesPage } from "../DigitalCoursesPage";
import { FinalModulePage } from "../FinalModulaPage";
export const RegistrationPage: React.FunctionComponent<RegistrationPageProps> = (
  props
) => {
  const { profilePicStatus } = props;
  // To maintain the state for the current page from API result
  // TODO: Replace the deafult count with the API's currentPage value
  const [currentPage, setCurrentPage] = React.useState<number>();
  // State to maintian whether the modal should be shown or not
  const [showMessageModal, setShowMessageModal] = React.useState<boolean>(
    false
  );
  // State to show loader in the Modal component
  const [showLoader, setShowLoader] = React.useState<boolean>(false);

  // State to maintain the dashboard Rediretion
  const [
    isRedirectBackButtonClicked,
    setIsRedirectBackButtonClicked,
  ] = React.useState<boolean>(false);
  // State for maintaining the SAVE AND QUIT click
  const [onSaveAndExitClick, setOnSaveAndExitClick] = React.useState(0);
  const isMobileView = useIsMobile();
  const isTabView = useIsTab();
  const history = useHistory();
  // Calling the SSO Hook to retrieve user information of the logged in user
  const user = useUserContext();
  // Calling the useMiscellaneousHook for retreiveing the data to be shown on the header of this page
  const getMiscellaneousdataFromHook = useMiscellaneousHook();
  const backBtnWithName = () => {
    return (
      <div className="d-flex align-items-center">
        <button
          onClick={redirectbackToDashboardScreenClick}
          className={`border-0 user-button-style ${
            isMobileView ? "bg-white" : ""
          }`}
        >
          <img src={backIcon} alt="" />
        </button>
        <div className={`ml-2 ${isMobileView ? "mt-25" : ""}`}>
          {_.get(getMiscellaneousdataFromHook, "message", "")}
        </div>
      </div>
    );
  };

  const [
    ,
    {
      result: postRevenueData,
      revalidator: refetchPostRevenueData,
      error: postRevenueDataError,
    },
  ] = useSTR(getData);

  React.useEffect(() => {
    refetchPostRevenueData(`${URL.getStatusDetails(_.get(user, "empId"))}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusListFromAPI = React.useMemo(() => {
    return postRevenueData && postRevenueData.steps;
  }, [postRevenueData]);

  const checkIfLastPage = React.useMemo(() => {
    let valid: boolean = false;
    setCurrentPage(currentPage);
    const stepsLength = postRevenueData?.steps?.length;
    if (stepsLength - 1 === currentPage) {
      valid = true;
    } else if (currentPage && stepsLength - 1 > currentPage) {
      valid = true;
      for (let i = currentPage + 1; i < stepsLength; i++) {
        if (postRevenueData.steps[i].type === "FORM") {
          valid = false;
          break;
        }
      }
    }
    return valid;
  }, [postRevenueData, currentPage]);

  React.useEffect(() => {
    if (postRevenueData) {
      const { currentStep } = postRevenueData;
      setCurrentPage(currentStep);
    }
  }, [postRevenueData]);

  const onNextClick = (nextPageRequest: any) => {
    setCurrentPage(
      statusListFromAPI &&
        getStepStringArrayFromAPI(statusListFromAPI) &&
        getStepStringArrayFromAPI(statusListFromAPI).indexOf(nextPageRequest)
    );
    mapScreenToregisEnum(nextPageRequest);
  };

  // Function which is called when the user clicks on the tab manually from the StatusBar component to the change the page
  const onStatusBarUserClick = (currentPageChangeRequested: number) => {
    if (
      currentPage &&
      allowScreenNavigationFromStatusComponent(
        getRequestedScreenIndex(
          currentPage,
          postRevenueData?.steps,
          currentPageChangeRequested
        ),
        postRevenueData?.currentStep
      )
    ) {
      setCurrentPage(
        postRevenueData &&
          getRequestedPageNumber(
            postRevenueData.steps,
            currentPageChangeRequested
          )
      );
    } else {
    }
  };

  const onBackBtnClick = () => {
    const prevPageName =
      statusListFromAPI && currentPage && statusListFromAPI[currentPage - 1];
    if (prevPageName) {
      statusListFromAPI &&
        setCurrentPage(
          getStepStringArrayFromAPI(statusListFromAPI).indexOf(
            prevPageName.step
          )
        );
      mapScreenToregisEnum(prevPageName.step);
    } else {
      // Impliment the Logout functionality here
      history.push(routeURL.landingPage);
    }
  };

  const mapScreenToregisEnum = (stepName: string, pageType?: string) => {
    // If the current page points to page type of Dashboadr, redirect user to DASHBOARD and break out of the function
    if (pageType === StepType.DASHBOARD) {
      history.push(routeURL.dashboard);
      return;
    }

    const arrayIndex =
      statusListFromAPI &&
      getStepStringArrayFromAPI(statusListFromAPI).indexOf(stepName);
    let pageNavigationDetails = {
      nextScreen:
        statusListFromAPI &&
        getStepStringArrayFromAPI(statusListFromAPI)[arrayIndex + 1],
      prevScreen:
        statusListFromAPI &&
        getStepStringArrayFromAPI(statusListFromAPI)[arrayIndex - 1],
    };

    switch (stepName) {
      case LeadState.BASIC_INFO:
        return {
          component: (
            <BasicInformationPage
              onBackButtonClick={onBackBtnClick}
              pageNavigationDetails={pageNavigationDetails}
              onNextClick={onNextClick}
              onSaveAndExitClick={onSaveAndExitClick}
              SuccessFullSaveObj={onSuccessFullSaveObj}
              isProfilePictureUpdated={profilePicStatus}
            />
          ),
        };

      case LeadState.KYC_UPLOAD:
        return {
          component: (
            <KYCDetailsPage
              onBackButtonClick={onBackBtnClick}
              pageNavigationDetails={pageNavigationDetails}
              onNextClick={onNextClick}
              onSaveAndExitClick={onSaveAndExitClick}
              SuccessFullSaveObj={onSuccessFullSaveObj}
            />
          ),
        };

      case LeadState.BANK_DETAILS:
        return {
          component: (
            <BankAccountDetails
              onBackButtonClick={onBackBtnClick}
              pageNavigationDetails={pageNavigationDetails}
              onNextClick={onNextClick}
              onSaveAndExitClick={onSaveAndExitClick}
              SuccessFullSaveObj={onSuccessFullSaveObj}
            />
          ),
        };

      case LeadState.PROFILE_SETUP:
        return {
          component: (
            <BasicProfileDetailsPage
              onBackButtonClick={onBackBtnClick}
              pageNavigationDetails={pageNavigationDetails}
              onNextClick={onNextClick}
              onSaveAndExitClick={onSaveAndExitClick}
              SuccessFullSaveObj={onSuccessFullSaveObj}
              isProfilePictureUpdated={profilePicStatus}
            />
          ),
        };

      case LeadState.LANGUAGE_PROFICIENCY_CHECK:
        return {
          component: (
            <LanguageProficiency
              onNextClick={onNextClick}
              onBackButtonClick={onBackBtnClick}
              pageNavigationDetails={pageNavigationDetails}
              onSaveAndExitClick={onSaveAndExitClick}
              SuccessFullSaveObj={onSuccessFullSaveObj}
            />
          ),
        };

      case LeadState.PRELIMINARY_QUIZ:
        return {
          component: (
            <PreliminaryQuizPage
              onBackButtonClick={onBackBtnClick}
              onSaveAndExitClick={onSaveAndExitClick}
            />
          ),
        };

      case LeadState.PROFESSIONAL_INFO:
        return {
          component: (
            <ProfessionalDetailsPage
              onBackButtonClick={onBackBtnClick}
              onNextClick={onNextClick}
              onSaveAndExitClick={onSaveAndExitClick}
              pageNavigationDetails={pageNavigationDetails}
              SuccessFullSaveObj={onSuccessFullSaveObj}
            />
          ),
        };

      case LeadState.DIGITAL_COURSES:
        return {
          component: (
            <DigitalCoursesPage
              onBackButtonClick={onBackBtnClick}
              onNextClick={onNextClick}
              onSaveAndExitClick={onSaveAndExitClick}
              pageNavigationDetails={pageNavigationDetails}
              SuccessFullSaveObj={onSuccessFullSaveObj}
            />
          ),
        };

      case LeadState.FINAL_ASSESSMENT_MODULE:
        return {
          component: (
            <FinalModulePage
              onBackButtonClick={onBackBtnClick}
              onSaveAndExitClick={onSaveAndExitClick}
              pageNavigationDetails={pageNavigationDetails}
              onNextClick={onNextClick}
              SuccessFullSaveObj={onSuccessFullSaveObj}
            />
          ),
        };

      case LeadState.SELFIE_VIDEO:
        return {
          component: (
            <SelfieVideoPage
              onBackButtonClick={onBackBtnClick}
              onSaveAndExitClick={onSaveAndExitClick}
              pageNavigationDetails={pageNavigationDetails}
              onNextClick={onNextClick}
              SuccessFullSaveObj={onSuccessFullSaveObj}
              isLastStep={checkIfLastPage}
            />
          ),
        };

      case LeadState.WORKSPACE_DETAILS:
        return {
          component: (
            <WorkPlaceDetails
              onNextClick={onNextClick}
              onBackButtonClick={onBackBtnClick}
              pageNavigationDetails={pageNavigationDetails}
              onSaveAndExitClick={onSaveAndExitClick}
              SuccessFullSaveObj={onSuccessFullSaveObj}
              isLastStep={checkIfLastPage}
            />
          ),
        };

      default:
        break;
    }
  };

  // Function which is called when the CANCEL button of the modal is clicked
  const onCancelClickOfConfirmModal = () => {
    // Close modal here
    setShowMessageModal(false);
    history.push(routeURL.dashboard);
  };

  // Function which is called when the CANCEL button of the modal is clicked from the cross ICON
  const onCloseIconClick = () => {
    // Close modal here
    setShowMessageModal(false);
  };

  // Function which is called when the user selects SAVE and EXIT from the modal's button
  const onApproveModalButtonClick = () => {
    toast.info("Making suitable changes as per your request. Please wait");
    setShowMessageModal(false);
    setShowLoader(true);
    setOnSaveAndExitClick((prevState) => prevState + 1);
  };

  // Function which is called when the back button in the registration screen is clicked
  const redirectbackToDashboardScreenClick = () => {
    setShowMessageModal(true);
    setIsRedirectBackButtonClicked(true);
  };

  // Function which is got from successfully saving
  const onSuccessFullSaveObj = (savedObj: boolean) => {
    setShowLoader(false);
    setShowMessageModal(false);
    // Rediret only when the back button is clicked from the registration page
    isRedirectBackButtonClicked && history.push(routeURL.dashboard);
  };

  return (
    <span css={[registrationPageStyle, responsiveStyles]}>
      <div className="status-background">
        <div
          className={`${
            isMobileView || isTabView ? "container-fluid" : "container"
          }`}
        >
          <div className="row">
            <div
              className={`col-12  ${
                isMobileView ? "p-0 custom-full-height" : "responsive-margin"
              }`}
            >
              <ShowMessage
                onCloseIconClick={onCloseIconClick}
                visible={showMessageModal}
                loading={showLoader}
                heading={
                  showLoader
                    ? loadingScreenValues.onSavingHeadingText
                    : loadingScreenValues.onSaveAndexitWarningHeadingText
                }
                description={
                  showLoader
                    ? loadingScreenValues.onSavingBodyText
                    : loadingScreenValues.onSaveAndExitWarningBodyText
                }
                footerButtons={
                  showLoader
                    ? []
                    : [
                        {
                          key: 1,
                          text: "EXIT",
                          color: CustomButtonColor.SECONDARY,
                          type: CustomButtonTypes.BUTTON,
                          onClick: onCancelClickOfConfirmModal,
                        },
                        {
                          key: 2,
                          text: saveandexit,
                          color: CustomButtonColor.PRIMARY,
                          type: CustomButtonTypes.BUTTON,
                          onClick: onApproveModalButtonClick,
                        },
                      ]
                }
              />
              <div className="fixed-custom-navbar-style d-sm-none d-xs-block d-flex">
                <div className="col-8 p-0">{backBtnWithName()}</div>
                <div className="col-4 p-0 text-right">
                  <LinkButton
                    className="save-exit-style "
                    onClick={() =>
                      setOnSaveAndExitClick((prevState) => prevState + 1)
                    }
                  >
                    {saveText}
                  </LinkButton>
                </div>
              </div>
              <div className="col-12  d-none d-sm-block p-0 py-4">
                {backBtnWithName()}
              </div>
              <Card
                className={`d-flex justify-content-center flex-column  ${
                  isMobileView || isTabView
                    ? "registration-custom-padding-responsive"
                    : "padding-container px-5 py-2"
                }`}
              >
                <div className="mb-2 mt-4">
                  {statusListFromAPI && (currentPage || currentPage === 0) && (
                    <StatusBar
                      currentState={getCurrentPageForStatusComponent(
                        statusListFromAPI,
                        currentPage
                      )}
                      statusData={
                        statusListFromAPI &&
                        getStatusComponentDisplayNames(statusListFromAPI)
                      }
                      showProgressDot
                      changeDirection={PropValuesEnum.HORIZONTAL}
                      onClickChange={onStatusBarUserClick}
                    />
                  )}
                </div>
              </Card>
              {postRevenueDataError && (
                <ErrorComponent errorObj={postRevenueDataError} />
              )}
              {statusListFromAPI &&
                (currentPage || currentPage === 0) &&
                mapScreenToregisEnum(
                  statusListFromAPI[currentPage] &&
                    statusListFromAPI[currentPage].step,
                  statusListFromAPI[currentPage] &&
                    statusListFromAPI[currentPage].type
                )?.component}
            </div>
          </div>
        </div>
      </div>
    </span>
  );
};
